import type { FaireProductEntity } from "../../entity_types/product";

export const p_qnf2n9b9tz: FaireProductEntity = {
  token: "p_qnf2n9b9tz",
  type: "product",
  name: "Meditating Buddha Statue - 24In High",
  brandToken: "b_6clm7lye",
  brandName: "Hi-Line Gift Ltd.",
  imageUrl:
    "https://cdn.faire.com/fastly/0e827b28d104db2693158d690506826858309e274198841409d65e33b1b3b64a.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/da10094901c364bc46999bcfff2b13da3a3e4ff3e31182a1cf517b991200b047.jpeg",
  ],
  priceDollars: 120.25,
  description:
    "Tune into zen and tranquility with this detailed 24in buddha statue. Place it in your home or garden and create a space for relaxation and meditation. Finely crafted detail.",
  tags: [],
  msrpDollars: 261,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:58:40.580Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
